import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'contact-cell',
    standalone: true,
    template: `
@if(rowData?.isDefaulter){
<span class="cell-text" (click)="$event.stopPropagation(); onCellClick(rowData)">{{
      rowData.contactnumber || rowData.contactNo
    }}</span>
}
  `,
    styles: [
        `
      .cell-text {
        font-family: var(--manrope);
        font-weight: 600;
        font-size: 16px;
        color: var(--brand-primary);
        cursor: pointer;
      }
    `,
    ],
})
export class ContactCellComponent {
    @Input() rowData: any;
    @Output() cellClick: EventEmitter<any> = new EventEmitter<any>();
    onCellClick(rowData: any) {
        console.log(rowData);
        this.cellClick.emit(rowData);
    }
}
